import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.backgrounds.editModalContent};
  padding: 21px 10px 21px 25px;
  height: 100%;
  position: relative;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 17.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.detailModalFields};
  margin-bottom: 19px;
`;
Title.displayName = 'Title';

export const Body = styled.div`
  overflow-y: auto;
  height: calc(100% - 35px);
  padding-right: 31px;
`;
Body.displayName = 'Body';
